import styles from "./Loading.module.scss";

const Loading = () => {
    return (
      <div className={styles.loadingOverlay}>
        <div className={styles.spinner}>
          <div className={styles.bounce1}></div>
          <div className={styles.bounce2}></div>
          <div className={styles.bounce3}></div>
        </div>
      </div>
    );
}

export default Loading;